export default __webpack_public_path__ + "static/media/arrow-right-circle.a1593ed4.svg";